export default __webpack_public_path__ + "static/media/img1.2ca5ce92.png";